import { api } from '~/application/api';
import type { ApplicationResult, CollectionResult } from '~/application/types';
import type { User, UserWithPermissions } from './types';

export const userApi = api.enhanceEndpoints({
    addTagTypes: ['CurrentUser', 'User'],
}).injectEndpoints({
    endpoints: build => ({
        changePassword: build.mutation<ApplicationResult, { id: number; password: string; }>({
            query: ({ id, ...body }) => ({
                url: `/users/${id}/change-password`,
                method: 'POST',
                body,
            }),
        }),
        createUser: build.mutation<ApplicationResult, Omit<User, 'id'> & { password: string; }>({
            query: (request) => ({
                url: '/users',
                method: 'POST',
                body: request,
            }),
            invalidatesTags: ['User'],
        }),
        currentUser: build.query<UserWithPermissions, void>({
            query: () => '/users/me',
            providesTags: ['CurrentUser'],
        }),
        deleteUser: build.mutation<ApplicationResult, number | string>({
            query: (id) => ({
                url: `/users/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['User'],
        }),
        listUsers: build.query<CollectionResult<User>, string>({
            query: (queryString) => `users?${queryString}`,
            providesTags: ['User'],
        }),
        updateUser: build.mutation<ApplicationResult, User>({
            query: (request) => ({
                url: `/users/${request.id}`,
                method: 'POST',
                body: request,
            }),
            invalidatesTags: ['User'],
        }),
        userDetails: build.query<User, number | string>({
            query: id => `/users/${id}`,
            providesTags: result => result
                ? [{ type: 'User', id: result.id }]
                : ['User'],
        }),
    }),
});

export const {
    useChangePasswordMutation,
    useCreateUserMutation,
    useDeleteUserMutation,
    useListUsersQuery,
    useUpdateUserMutation,
    useUserDetailsQuery,
} = userApi;
